import { MenuItem } from '@mui/material'
import { InvoiceReadModel, InvoiceState, MarkInvoiceAsPastDueCommand } from '../../GeneratedClients/FreeBillApi';
import { useNotify, useRecordContext, useRefresh, useTranslate } from 'react-admin';
import { apiService } from '../../apiService';
import { useMutation } from "react-query";
import firstLetterToLowerCase from '../../helpers/firstLetterToLowerCase';

interface IProps {
  handleClose: () => void
}

const InvoiceMarkAsPastDueMenuItem= ({handleClose}: IProps) => {
  
  const invoice = useRecordContext<InvoiceReadModel>()
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const { mutate, isLoading } = useMutation((command: MarkInvoiceAsPastDueCommand) => 
    apiService.InvoicesApi.markInvoiceAsPastDue({markInvoiceAsPastDueCommand: command, id: command.id!}),
    {
      onSuccess: () => {
        notify(translate("resources.invoices.notifications.invoiceStateChanged"))
        refresh()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const markInvoiceAsPastDue = () => { 
    if(invoice.invoiceState === InvoiceState.Canceled) {
      notify(translate("resources.invoices.dialogs.invalidStateChange", {actualState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.Canceled)}`), newState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.PastDue)}`)}), {type: "error"}) 
      return
    }
    if(invoice.invoiceState === InvoiceState.PastDue) {
      notify(translate("resources.invoices.dialogs.alreadyThatState", {actualState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.PastDue)}`)}), {type: "error"}) 
      return
    }
    const command: MarkInvoiceAsPastDueCommand = {
      id: invoice.id,
      userId: invoice.userId,
    }
    mutate(command)
    handleClose()
  }

  return (
    <MenuItem 
      disabled={isLoading} 
      onClick={markInvoiceAsPastDue} 
      key={"markInvoiceAsPastDue"}
    >
      {translate(`resources.invoices.pastDue`)}
    </MenuItem>
  )
}

export default InvoiceMarkAsPastDueMenuItem